import { getCountry } from "react-international-phone";
/**
 * Keeps only digits from a local phone input (allows leading 0).
 */
export function sanitizePhoneLocal(value) {
    return value.replace(/\D/g, "");
}
/**
 * Builds an E.164 phone string from a country and local subscriber number.
 * Strips leading national trunk zeros before prefixing the ITU dial code.
 */
export function formatPhoneE164(countryIso2, localNumber) {
    const country = getCountry({ field: "iso2", value: countryIso2 });
    if (!country) {
        throw new Error(`Unknown country code: ${countryIso2}`);
    }
    const digits = sanitizePhoneLocal(localNumber).replace(/^0+/, "");
    if (!digits) {
        return "";
    }
    return `+${country.dialCode}${digits}`;
}
/**
 * Returns true when the local number has enough digits for the selected country.
 */
export function isLocalPhoneComplete(countryIso2, localNumber) {
    const digits = sanitizePhoneLocal(localNumber).replace(/^0+/, "");
    if (!digits) {
        return false;
    }
    // Argentina: area code + subscriber (typically 10 digits without 0/15).
    if (countryIso2 === "ar") {
        return digits.length >= 10;
    }
    return digits.length >= 8;
}
